import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/four`; // Adjust this as necessary

export const createFour = (fourData) => axios.post(`${API_BASE_URL}/createfour`, fourData);

export const getFourById = (id) => axios.get(`${API_BASE_URL}/getfour/${id}`);

export const updateFour = (id, fourData) => axios.put(`${API_BASE_URL}/updatefour/${id}`, fourData);

export const deleteFour = (id) => axios.delete(`${API_BASE_URL}/deletefour/${id}`);

export const getAllFours = () => axios.get(`${API_BASE_URL}/getallfour`);

export const bulkUploadFournisseurs = (formData) => axios.post(`${API_BASE_URL}/bulk-upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

// Seed DBF upload API
export const uploadFournisseursDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-fournisseurs`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });